import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Logo } from "../../assets/images";

function CannotAccess({ message }) {
  const { t } = useTranslation();
  return (
    <div
      className="container d-flex justify-content-center align-items-center h-screen flex-column"
      style={{ maxWidth: 2100, height: "100vh", overflow: "hidden" }}
    >
      <img src={Logo} className="img-fluid mb-4 max-w-400" alt="logo" />
      <h4 className="fw-bold">Oops!!</h4>
      <p>{message}</p>
      <Link to={-1} className="btn btn-primary">
        {t("beranda")}
      </Link>
    </div>
  );
}

export default CannotAccess;
